import {ComponentType} from "react";
import {IError} from "modules/types";

type Factory<T> = () => Promise<{default: ComponentType<T>}>;

function attemptLoad<T>(
	fn: Factory<T>,
	retriesLeft: number,
	interval: number,
	resolve: (value: {default: ComponentType<T>}) => void,
	reject: (error: IError) => void
): void {
	fn()
		.then(resolve)
		.catch((error: IError) => {
			if (retriesLeft <= 1) {
				reject(error);
				return;
			}
			setTimeout(() => {
				attemptLoad(fn, retriesLeft - 1, interval, resolve, reject);
			}, interval);
		});
}

export function retryFailLoad<T>(fn: Factory<T>, retriesLeft = 5, interval = 1000): Factory<T> {
	return () =>
		new Promise((resolve, reject) => {
			attemptLoad(fn, retriesLeft, interval, resolve, reject);
		});
}
